<template>
  <div class="mb-3 mt-3">
    <b-container>
      <h1 class="text-primary font-weight-bold text-center mb-5">{{ $t('queen_edit.title') }}</h1>
      <queen-form :id="id" :colony="colony" :apiary="apiary"></queen-form>
    </b-container>
  </div>
</template>

<script>
import QueenForm from '../components/QueenForm'
export default {
  name: 'QueenEdit',
  components: { QueenForm },
  props: ['id', 'colony', 'apiary']
}
</script>

<style scoped>

</style>
